let demoApi = (window.location.protocol.indexOf('https') !== -1 ? 'https://qapi.seeed.cn' : 'https://qapi.seeed.cn');
let str = window.location.protocol.indexOf('https') !== -1 ? 's' : '';
// let testApi = 'http://192.168.117.54:30001';
// demoApi = testApi;
let apiUrl = {
  needLogin: {
    url: demoApi + '/ws/needLogin', // 是否需要登录
    method: 'get'
  },
  templateLogin: {
    url: demoApi + '/ws/templateLogin', // 登录接口
    method: 'post'
  },
  getTemplateData: {
    url: demoApi + '/ws/getTemplateData', // 获取模板页面信息
    method: 'get'
  },
  getWeatherList: {
    url: demoApi + '/ws/getWeatherListV1', // 获取天气信息
    method: 'get'
  },
  getConditionWeatherInfo: {
    url: demoApi + '/ws/getConditionWeatherInfoV1', // 获取24小时天气信息
    method: 'get'
  },
  getAlertInfo: {
    url: demoApi + '/ws/getAlertInfo', // 天气预警信息
    method: 'get'
  },
  getJsConfig: {
    url: demoApi + '/ws/getJsConfig', // 获取微信信息
    method: 'get'
  },
}

window.apiUrl = apiUrl

let cancelTokens = []
window.cancelTokens = cancelTokens

window.str = str

export {
  apiUrl,
  cancelTokens,
  str
}
